import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", amount = 0.15 }) {
    const reduce = useReducedMotion();
    if (reduce) return <div className={className}>{children}</div>;
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount }}
            transition={{ duration: 0.8, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, animate = true }) {
    const reduce = useReducedMotion();
    return (
        <span className={`block ${className}`}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
                    <motion.span
                        className={`block will-change-transform ${lineClassName}`}
                        initial={animate && !reduce ? { y: "112%" } : false}
                        animate={animate && !reduce ? { y: "0%" } : {}}
                        transition={{ duration: 1, delay: delay + i * 0.1, ease: EASE }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </span>
    );
}

export function RuleDraw({ className = "", delay = 0.4, light = false }) {
    const reduce = useReducedMotion();
    return (
        <motion.span
            aria-hidden="true"
            className={`block h-px w-full origin-left ${light ? "bg-white/30" : "bg-line-2"} ${className}`}
            initial={reduce ? false : { scaleX: 0 }}
            animate={reduce ? {} : { scaleX: 1 }}
            transition={{ duration: 1.2, delay, ease: EASE }}
        />
    );
}
